import sdl from '@jds/react-generated-sdl/JDSFileUploaderList';
import type { JDSFileUploaderListProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFileUploaderListProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { showDivider = true, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { showDivider, ...rest },
    'JDSFileUploaderList',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FileUploaderList = withLogic(
  Component
) as React.FC<JDSFileUploaderListProps> & { slotName?: string };

FileUploaderList.displayName = 'FileUploaderList';
FileUploaderList.slotName = 'jds_file_uploader_list';

export { FileUploaderList, type JDSFileUploaderListProps };
